export default __webpack_public_path__ + "static/media/kansKlein.75c22c08.jpg";